import React, { FC } from 'react';
import { FormCheck } from 'react-bootstrap';
import { FormCheckLabelProps } from 'react-bootstrap/FormCheckLabel';
import styles from './Tag.module.scss';

export type FormTagLabelProps = FormCheckLabelProps & {};

export const FormTagLabel: FC<FormTagLabelProps> = ({ ...props }) => {
	return <FormCheck.Label {...props} className={styles.tagLabel} bsPrefix="form-tag-label" />;
};
